import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useTranslation } from "react-i18next";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import GeneralSettings from "../GeneralSettings";
import { UsersContainer } from "../UsersContainer";
import APISettings from "../APISettings";
import SMPTUpdateForm from "../SMTPSettings";
import SMSUpdateForm from "../SMSContainer";
import VoiceUpdateForm from "../VoiceSettings";
import WhatsappUpdateForm from "../WhatsappSettings";
import OpenAISettings from "../OpenAISettings";
import ShortsUpdateForm from "../ShortsSettings";
import WebhookUpdateForm from "../WebhookUpdateForm";
import IpGeolocationUpdateForm from "../IpGeolocationSettings";
export default function IntegrationSettingsContainer() {
  const [value, setValue] = React.useState("0");

  const { t } = useTranslation();
  const handleChange = (event: any, newValue: string) => {
    setValue(newValue);
  };

  const tabs = [
    {
      name: "SMTP",
      component: <SMPTUpdateForm />,
    },
    {
      name: "SMS",
      component: <SMSUpdateForm />,
    },
    {
      name: "Voice",
      component: <VoiceUpdateForm />,
    },
    {
      name: "Whatsapp",
      component: <WhatsappUpdateForm />,
    },
    {
      name: "OpenAI",
      component: <OpenAISettings />,
    },
    {
      name: "ShortIO",
      component: <ShortsUpdateForm />,
    },
    {
      name: "Webhook",
      component: <WebhookUpdateForm />,
    },
    {
      name: "Ip Geolocation",
      component: <IpGeolocationUpdateForm />,
    },
  ];
  return (
    <>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            color: "black",
            mb: 5,
          }}
        >
          <TabList
            centered
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            {tabs.map((tab: ITab, index: number) => (
              <Tab
                value={index.toString()}
                key={index + tab.name}
                label={tab.name}
              />
            ))}
          </TabList>
        </Box>
      </TabContext>
      <div>
        <React.Fragment>
          {tabs[Number(value)].component}
          {/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleComplete} sx={{ mr: 1 }}>
              Next
            </Button>
          </Box> */}
        </React.Fragment>
      </div>
    </>
  );
}

interface ITab {
  component: React.ReactNode;
  name: string;
}
